export function StatusPill({ status, size = "md" }) {
  const label = (status || "").replace("-", " ").toUpperCase();
  const cls = `status-pill pill-${status} ${size === "sm" ? "py-0.5 text-[10.5px]" : ""}`;
  return (
    <span className={cls}>
      <span className="dot" />
      {label}
    </span>
  );
}

export default StatusPill;
